import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cbeb9a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "21",
  viewBox: "0 0 23 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.26264 5.42834C6.80293 5.42376 7.33008 5.58615 7.76416 5.89089C8.19824 6.19563 8.51558 6.62611 8.66808 7.11707C8.75145 7.40807 8.77269 7.7119 8.73058 8.01077C8.68847 8.30964 8.58385 8.59756 8.42283 8.85767C8.26181 9.11778 8.04764 9.34486 7.79285 9.52562C7.53805 9.70638 7.24775 9.83719 6.93893 9.9104C6.68916 9.96863 6.38752 10.0196 5.66127 10.2034C5.61733 10.2149 5.57626 10.2346 5.54048 10.2613C5.5047 10.2881 5.47492 10.3213 5.4529 10.3592C5.43088 10.397 5.41707 10.4386 5.41227 10.4815C5.40747 10.5244 5.41178 10.5679 5.42496 10.6092L5.6632 11.903C5.6632 11.903 1.61697 10.5692 1.34799 10.4563C0.917118 10.2732 0.556832 9.96797 0.316798 9.58274C0.0767636 9.19751 -0.0311981 8.75124 0.00779494 8.30546C0.046788 7.85967 0.230816 7.43632 0.53451 7.09375C0.838204 6.75119 1.24661 6.50629 1.70343 6.39281C2.38356 6.22357 4.91005 5.66491 5.6459 5.49931C5.8476 5.45164 6.05476 5.4278 6.26264 5.42834ZM6.28377 12.5254H6.3856C6.70367 12.5408 7.01528 12.6163 7.30215 12.7473C7.58903 12.8783 7.84539 13.0623 8.0562 13.2884C8.26701 13.5145 8.42803 13.7782 8.5298 14.064C8.63157 14.3499 8.67206 14.6521 8.64887 14.9529C8.62966 15.1968 8.58739 15.4843 8.54896 16.1977C8.54638 16.2407 8.55294 16.2838 8.56827 16.3244C8.58359 16.365 8.60737 16.4023 8.63819 16.434C8.66901 16.4658 8.70624 16.4913 8.74768 16.5092C8.78912 16.527 8.83392 16.5368 8.87943 16.538L10.2512 16.7199C10.2512 16.7199 7.6671 19.9573 7.4692 20.1629C7.25685 20.3869 6.99705 20.5661 6.70674 20.6887C6.41642 20.8113 6.1021 20.8746 5.78424 20.8744C5.74005 20.8744 5.69586 20.8744 5.65167 20.8744C5.35276 20.858 5.06022 20.7858 4.79076 20.6622C4.5213 20.5386 4.2802 20.3659 4.08125 20.1539C3.8823 19.942 3.7294 19.695 3.63128 19.4271C3.53317 19.1592 3.49176 18.8756 3.50944 18.5925C3.54978 17.9246 3.77842 15.4734 3.83221 14.7546C3.87109 14.1593 4.14467 13.5996 4.59874 13.1864C5.05281 12.7731 5.65422 12.5366 6.28377 12.5236V12.5254ZM16.4954 14.0649C16.4954 14.0649 18.9373 17.3987 19.0834 17.6407C19.3208 18.028 19.4252 18.4756 19.3821 18.9216C19.3389 19.3675 19.1504 19.7898 18.8426 20.1297C18.5348 20.4696 18.1229 20.7104 17.6642 20.8188C17.2054 20.9271 16.7224 20.8976 16.2821 20.7343C15.627 20.4923 13.2427 19.5278 12.5395 19.2549C11.938 19.0282 11.4521 18.5904 11.1832 18.0326C10.9144 17.4748 10.8833 16.8403 11.0966 16.2614C11.2089 15.9798 11.3794 15.7224 11.5982 15.5042C11.817 15.286 12.0796 15.1114 12.3707 14.9907C12.6617 14.87 12.9753 14.8056 13.293 14.8013C13.6106 14.797 13.926 14.8529 14.2206 14.9657C14.4588 15.0567 14.7336 15.1841 15.4368 15.4406C15.4774 15.4577 15.5211 15.4669 15.5655 15.4679C15.636 15.4676 15.7047 15.4466 15.7622 15.4078C15.8196 15.3691 15.863 15.3144 15.8863 15.2514L16.4954 14.0649ZM20.6146 6.32548C21.1396 6.32432 21.6486 6.49681 22.0537 6.81317C22.5214 7.17686 22.8178 7.70135 22.878 8.27169C22.9381 8.84202 22.7571 9.41168 22.3745 9.85581C21.9288 10.3726 20.2265 12.2215 19.7366 12.7783C19.4978 13.0498 19.1992 13.2684 18.8616 13.4187C18.524 13.5689 18.1557 13.6473 17.7827 13.6482C17.327 13.6506 16.8803 13.5288 16.4956 13.2975C16.111 13.0662 15.8047 12.735 15.6132 12.3434C15.4216 11.9518 15.353 11.5164 15.4154 11.0889C15.4778 10.6614 15.6686 10.2599 15.9651 9.93224C16.1304 9.75026 16.3494 9.53735 16.8163 8.98232C16.8449 8.94872 16.8662 8.91002 16.8788 8.86852C16.8915 8.82701 16.8952 8.78352 16.8898 8.74062C16.8845 8.69772 16.8701 8.65627 16.8476 8.61872C16.825 8.58116 16.7948 8.54825 16.7586 8.52193L15.7634 7.61205C15.7634 7.61205 19.8576 6.43466 20.1439 6.37825C20.2987 6.34772 20.4565 6.33247 20.6146 6.33276V6.32548ZM11.4443 1.73238e-06C11.8269 -0.000457317 12.2034 0.0903203 12.5392 0.263964C12.875 0.437608 13.1592 0.688529 13.3656 0.993589C13.7499 1.55589 15.0775 3.66681 15.479 4.28007C15.8263 4.79746 15.9492 5.42187 15.8221 6.02303C15.6951 6.62418 15.3278 7.15564 14.797 7.5065C14.4124 7.74708 13.961 7.87378 13.5001 7.87045C13.0924 7.87068 12.6914 7.77236 12.335 7.5848C11.9786 7.39724 11.6787 7.12664 11.4636 6.79861C11.3291 6.58934 11.185 6.33458 10.7757 5.73406C10.7508 5.69817 10.7185 5.66736 10.6808 5.64341C10.6431 5.61945 10.6008 5.60284 10.5563 5.59454C10.5117 5.58625 10.4659 5.58642 10.4215 5.59507C10.377 5.60371 10.3348 5.62065 10.2973 5.64489L9.07348 6.26179C9.07348 6.26179 9.15993 2.20009 9.1926 1.92349C9.25218 1.39659 9.51485 0.909012 9.93032 0.55411C10.3458 0.199208 10.8849 0.00191517 11.4443 1.73238e-06Z",
    fill: "#2F384C"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "content-container"
}
const _hoisted_4 = {
  key: 0,
  class: "mailboxes"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mailbox-body" }
const _hoisted_7 = { class: "messages" }
const _hoisted_8 = {
  key: 1,
  class: "no-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequestNotificationPermissionPanel = _resolveComponent("RequestNotificationPermissionPanel")!
  const _component_EngagementBanner = _resolveComponent("EngagementBanner")!
  const _component_NoticeRow = _resolveComponent("NoticeRow")!
  const _component_Scrollable = _resolveComponent("Scrollable")!
  const _component_NoticeMessage = _resolveComponent("NoticeMessage")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_PortalContainer = _resolveComponent("PortalContainer")!
  const _component_RequestNotificationPermissionModal = _resolveComponent("RequestNotificationPermissionModal")!
  const _component_ScreenBottomButton = _resolveComponent("ScreenBottomButton")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    class: "mailbox-container",
    "no-pad": "",
    title: "Notices",
    "disable-when-offline": ""
  }, {
    "left-button": _withCtx(() => [
      (_ctx.embedded)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "drawer-icon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOpenDrawer && _ctx.onOpenDrawer(...args)))
          }, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!_ctx.embedded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.canSendNotices || _ctx.sent.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (tab !== 'scheduled' || _ctx.canSendNotices)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: tab,
                            class: _normalizeClass(['mailbox', tab, { active: _ctx.mailbox === tab }]),
                            onClick: ($event: any) => (_ctx.goMailbox(tab))
                          }, _toDisplayString(tab), 11, _hoisted_5))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_RequestNotificationPermissionPanel),
              _createVNode(_component_Scrollable, {
                "pull-down": _ctx.refreshMailbox,
                "bottom-padding": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EngagementBanner),
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.messages.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.messages, (message) => {
                          return (_openBlock(), _createBlock(_component_NoticeRow, {
                            key: message.id,
                            mailbox: _ctx.mailbox,
                            recipients: _ctx.recipients,
                            message: message,
                            onClick: ($event: any) => (_ctx.onClickMessage(message))
                          }, null, 8, ["mailbox", "recipients", "message", "onClick"]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.emptyMessage), 1))
                  ])
                ], undefined, true),
                _: 1
              }, 8, ["pull-down"])
            ]),
            (_ctx.showMessageModal)
              ? (_openBlock(), _createBlock(_component_PortalContainer, {
                  key: 1,
                  onBack: _ctx.onClose
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Modal, {
                      vanilla: "",
                      show: _ctx.showMessageModal,
                      size: _ctx.modalSize.Full,
                      "has-close": false,
                      "allow-click-out": true,
                      close: _ctx.onClose
                    }, {
                      default: _withCtx(() => [
                        (!!_ctx.message)
                          ? (_openBlock(), _createBlock(_component_NoticeMessage, {
                              key: 0,
                              id: _ctx.message.id,
                              message: _ctx.message,
                              "message-type": _ctx.messageType,
                              mailbox: _ctx.mailbox,
                              onClose: _ctx.onClose
                            }, null, 8, ["id", "message", "message-type", "mailbox", "onClose"]))
                          : _createCommentVNode("", true)
                      ], undefined, true),
                      _: 1
                    }, 8, ["show", "size", "close"])
                  ], undefined, true),
                  _: 1
                }, 8, ["onBack"]))
              : _createCommentVNode("", true),
            _createVNode(_component_RequestNotificationPermissionModal)
          ]))
        : _createCommentVNode("", true),
      (_ctx.canSendNotices)
        ? (_openBlock(), _createBlock(_component_ScreenBottomButton, {
            key: 1,
            icon: _ctx.iconPencil,
            title: "Send Notice",
            onClick: _ctx.goCompose
          }, null, 8, ["icon", "onClick"]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}